import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios";

const initialState = {
  sessions: {
    sessionData: [],
    sessionLoading: false,
    sessionTotal: 0,
    sessionPage: 0,
    sessionLimit: 25,
  },
  sessionResources: {
    sessionResourcesData: [],
    sessionResourcesLoading: false,
    sessionResourcesTotal: 0,
    sessionResourcesPage: 0,
    sessionResourcesLimit: 25,
    searchResourceKey: "",
  },
  sessionQuizzes: {
    sessionQuizzesData: [],
    sessionQuizzesLoading: false,
    sessionQuizzesTotal: 0,
    sessionQuizzesPage: 1,
    sessionQuizzesLimit: 25,
    searchQuizzesKey: "",
  },
  sessionFeedback: {
    sessionFeedbackData: [],
    sessionFeedbackLoading: false,
    sessionFeedbackTotal: 0,
    sessionFeedbackPage: 1,
    sessionFeedbackLimit: 25,
    searchFeedbackKey: "",
  },
  sessionWiseFeedback: {
    sessionWiseFeedbackData: [],
    sessionWiseFeedbackLoading: false,
    sessionWiseFeedbackTotal: 0,
    sessionWiseFeedbackPage: 1,
    sessionWiseFeedbackLimit: 25,
    searchWiseFeedbackKey: "",
  },
};

export const fetchBatchSessions = createAsyncThunk(
  "/batchSessionManagement/fetchBatchSessions",
  async ({ batchId = "", sessionLimit = 25, sessionPage = 0 }, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/sessions?batchId=${batchId}&pageLength=${sessionLimit}&pageNo=${
          sessionPage + 1
        }`
      );
      return {
        statusCode: data?.statusCode,
        data: data?.payload?.sessions,
        total: data?.payload?.total,
      };
    } catch (error) {
      throw error;
    }
  }
);

export const fetchSessionResources = createAsyncThunk(
  "/batchSessionManagement/fetchBatchResources",
  async (
    {
      sessionId = "",
      sessionResourcesPage = "",
      sessionResourcesLimit = "",
      searchResourceKey = "",
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/resources?pageLength=${sessionResourcesLimit}&pageNo=${
          sessionResourcesPage + 1
        }&sessionId=${sessionId}&resourceName=${searchResourceKey}`
      );
      return {
        statusCode: data.statusCode,
        data: data?.payload?.resources,
        total: data?.payload?.totalItems,
      };
    } catch (error) {
      throw error;
    }
  }
);
export const fetchSessionQuizzes = createAsyncThunk(
  "/batchSessionManagement/fetchBatchQuizzes",
  async (
    {
      sessionId = "",
      sessionQuizzesPage = "",
      sessionQuizzesLimit = "",
      searchQuizzesKey = "",
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/quiz?pageLength=${sessionQuizzesLimit}&pageNo=${sessionQuizzesPage}&sessionId=${sessionId}&quizName=${searchQuizzesKey}`
      );
      return {
        statusCode: data.statusCode,
        data: data?.payload?.quizzes,
        total: data?.payload?.totalItems,
      };
    } catch (error) {
      throw error;
    }
  }
);
export const fetchSessionFeedback = createAsyncThunk(
  "/batchSessionManagement/fetchBatchFeedback",
  async ({
    batchId = "",
    sessionFeedbackPage = "",
    sessionFeedbackLimit = "",
  }) => {
    try {
      console.log(batchId);
      const response = await axiosInstance.get(
        `/sessions/batch/feedbacks/${batchId}?pageLength=${sessionFeedbackLimit}&pageNo=${sessionFeedbackPage}`
      );
      console.log(response);
      return {
        statusCode: response?.data.statusCode,
        data: response?.data?.payload.feedbacks,
        total: response?.data?.payload?.totalFeedback,
      };
    } catch (error) {
      throw error;
    }
  }
);
export const fetchSessionWiseFeedback = createAsyncThunk(
  "/batchSessionManagement/fetchBatchSessionWiseFeedback",
  async ({
    sessionId = "",
    sessionWiseFeedbackPage = "",
    sessionWiseFeedbackLimit = "",
  }) => {
    try {
      const response = await axiosInstance.get(
        `/sessions/feedbacks/${sessionId}?pageLength=${sessionWiseFeedbackLimit}&pageNo=${sessionWiseFeedbackPage}`
      );
      console.log(response);
      return {
        statusCode: response?.data.statusCode,
        data: response?.data?.payload.feedbacks,
        total: response?.data?.payload?.totalFeedback,
      };
    } catch (error) {
      throw error;
    }
  }
);

const batchSessionManagementSlice = createSlice({
  name: "batchSessionManagement",
  initialState,
  reducers: {
    setSessionsPaginationModel(state, action) {
      state.sessions.sessionPage = action.payload?.page;
      state.sessions.sessionLimit = action.payload?.pageSize;
    },
    resetSessionsPaginationModel(state, action) {},
    setResourcePaginationModel(state, action) {
      state.sessionResources.sessionResourcesPage = action.payload.page;
      state.sessionResources.sessionResourcesLimit = action.payload.pageSize;
    },

    // resourcePageChanged(state, action) {
    //   console.log(action.payload);
    //   state.sessionResources.sessionResourcesPage = action.payload;
    // },
    // resourcePageLimit(state, action) {
    //   console.log(action.payload);

    //   state.sessionResources.sessionResourcesLimit = action.payload;
    // },
    searchResourceKeyChanged(state, action) {
      console.log(action.payload);

      state.sessionResources.searchResourceKey = action.payload;
    },

    QuizPageChanged(state, action) {
      console.log(action.payload);
      state.sessionQuizzes.sessionQuizzesPage = action.payload;
    },
    QuizPageLimit(state, action) {
      console.log(action.payload);

      state.sessionQuizzes.sessionQuizzesLimit = action.payload;
    },
    FeedbackPageChanged(state, action) {
      console.log(action.payload);
      state.sessionFeedback.sessionFeedbackPage = action.payload;
    },
    FeedbackPageLimit(state, action) {
      console.log(action.payload);

      state.sessionFeedback.sessionFeedbackLimit = action.payload;
    },
    SessionWiseFeedbackPageChanged(state, action) {
      console.log(action.payload);
      state.sessionWiseFeedback.sessionWiseFeedbackPage = action.payload;
    },
    SessionWiseFeedbackPageLimit(state, action) {
      console.log(action.payload);

      state.sessionWiseFeedback.sessionWiseFeedbackLimit = action.payload;
    },

    searchQuizKeyChanged(state, action) {
      state.sessionQuizzes.searchQuizzesKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBatchSessions.pending, (state) => {
      state.sessions.sessionLoading = "pending";
      state.sessions.sessionData = [];
    });
    builder.addCase(fetchBatchSessions.fulfilled, (state, action) => {
      state.sessions.sessionData = action.payload?.data;
      state.sessions.sessionTotal = action.payload?.total;
      state.sessions.sessionLoading = "succeeded";
    });
    builder.addCase(fetchBatchSessions.rejected, (state, action) => {
      state.sessions.sessionLoading = "failed";
    });

    builder.addCase(fetchSessionResources.pending, (state) => {
      state.sessionResources.sessionResourcesLoading = "pending";
      state.sessionResources.sessionResourcesData = [];
    });
    builder.addCase(fetchSessionResources.fulfilled, (state, action) => {
      state.sessionResources.sessionResourcesData = action.payload?.data;
      state.sessionResources.sessionResourcesTotal = action.payload?.total;
      state.sessionResources.sessionResourcesLoading = "succeeded";
    });
    builder.addCase(fetchSessionResources.rejected, (state, action) => {
      state.sessionResources.sessionResourcesLoading = "failed";
    });
    builder.addCase(fetchSessionQuizzes.pending, (state) => {
      state.sessionQuizzes.sessionQuizzesLoading = "pending";
      state.sessionQuizzes.sessionQuizzesData = [];
    });
    builder.addCase(fetchSessionQuizzes.fulfilled, (state, action) => {
      state.sessionQuizzes.sessionQuizzesData = action.payload?.data;
      state.sessionQuizzes.sessionQuizzesTotal = action.payload?.total;
      state.sessionQuizzes.sessionQuizzesLoading = "succeeded";
    });
    builder.addCase(fetchSessionQuizzes.rejected, (state, action) => {
      state.sessionQuizzes.sessionQuizzesLoading = "failed";
    });
    builder.addCase(fetchSessionFeedback.pending, (state) => {
      state.sessionFeedback.sessionFeedbackLoading = "pending";
      state.sessionFeedback.sessionFeedbackData = [];
    });
    builder.addCase(fetchSessionFeedback.fulfilled, (state, action) => {
      state.sessionFeedback.sessionFeedbackData = action.payload.data;
      state.sessionFeedback.sessionFeedbackTotal = action.payload.total;
      state.sessionFeedback.sessionFeedbackLoading = "succeeded";
    });
    builder.addCase(fetchSessionFeedback.rejected, (state, action) => {
      state.sessionFeedback.sessionFeedbackLoading = "failed";
    });
    builder.addCase(fetchSessionWiseFeedback.pending, (state) => {
      state.sessionWiseFeedback.sessionWiseFeedbackLoading = "pending";
      state.sessionWiseFeedback.sessionWiseFeedbackData = [];
    });
    builder.addCase(fetchSessionWiseFeedback.fulfilled, (state, action) => {
      state.sessionWiseFeedback.sessionWiseFeedbackData = action.payload.data;
      state.sessionWiseFeedback.sessionWiseFeedbackTotal = action.payload.total;
      state.sessionWiseFeedback.sessionWiseFeedbackLoading = "succeeded";
    });
    builder.addCase(fetchSessionWiseFeedback.rejected, (state, action) => {
      state.sessionWiseFeedback.sessionWiseFeedbackLoading = "failed";
    });
  },
});

export const {
  setSessionsPaginationModel,
  resetSessionsPaginationModel,
  resourcePageLimit,
  resourcePageChanged,
  QuizPageChanged,
  QuizPageLimit,
  FeedbackPageChanged,
  FeedbackPageLimit,
  SessionWiseFeedbackPageChanged,
  SessionWiseFeedbackPageLimit,
  searchQuizKeyChanged,
  searchResourceKeyChanged,
  setResourcePaginationModel,
} = batchSessionManagementSlice.actions;

export default batchSessionManagementSlice.reducer;
